import React, { useState } from 'react';

import SearchForm from '../../../../AddOrEditPage/SearchForm';
import Button from '../../../../Button';

import BorrowerService from '../../../../../services/BorrowerService';
import SearchService from '../../../../../services/SearchService';

import saveSelectedResultAndRecordChange from '../helpers/saveSelectedResultAndRecordChange';

export default function Search({
  lenderId,
  type,
  setIsMessageVisible,
  updateDocument,
}) {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const isBorrower = type.includes('orrower');

  return (
    <div>
      {isSearchVisible ? (
        <SearchForm
          placeholder={`Search ${type}s`}
          noResultsText={`No ${type.toLowerCase()}s found`}
          queryKey={
            isBorrower ? ['importNoteBorrower', lenderId] : ['importNoteVendor']
          }
          queryFnParams={isBorrower ? { lenderId } : { type: ['Insurance'] }}
          queryFn={
            isBorrower
              ? ({ query }) => BorrowerService.searchBorrowers({ query })
              : SearchService.searchVendors
          }
          onResultSelect={(selectedResult) => {
            saveSelectedResultAndRecordChange(
              selectedResult,
              type,
              updateDocument
            );
          }}
          formatSearchResult={isBorrower ? null : (vendor) => vendor.name}
        />
      ) : (
        <Button
          onClick={() => {
            setIsSearchVisible(true);
            setIsMessageVisible(false);
          }}
        >
          Find existing {type.toLowerCase()}
        </Button>
      )}
    </div>
  );
}
